module.exports = __webpack_public_path__ + "img/block-l-3-m.ef7359a3.png";